export default "__VITE_ASSET__DazEH6Cj__"